export default __webpack_public_path__ + "static/media/PrintedMaterial5.5bbe318b.png";